import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";
import { PagingResponse } from "../model/interface/pagingResponse";
import { IPagingSortingRequest } from "../model/interface/pagingRequest";

export interface ILessonPlan {
  lessonPlanId: number;
  subjectId: number;
  subjectName: string;
  isApproved: boolean;
  assetCount: number;
}

export interface IAddLessonPlanCommand {
  subjectId: number;
  isApproved: boolean;
}

export interface IUpdateLessonPlanCommand {
  subjectId: number;
  isApproved: boolean;
}

export interface IAddLessonPlanAssetCommand {
  title: string;
  standardCodes: string;
  description: string;
  isActive: boolean;
  file: any | undefined;
  ordinal: number;
}

export interface IUpdateLessonPlanAssetCommand {
  title: string;
  standardCodes: string;
  description: string;
  isActive: boolean;
  file: any | undefined;
  ordinal: number;
}

export interface ILessonPlanSubject {
  subjectId: number;
  name: string;
  hasLessonPlan: boolean;
}

export interface ILessonPlanAsset {
  lessonPlanAssetId: number;
  lessonPlanId: number;
  title: string;
  standardCodes: string;
  description: string;
  isActive: boolean;
  fileExtension: string;
  ordinal: number;
}

export type ILessonPlanSearch = IPagingSortingRequest;

export const addLessonPlan = (command: IAddLessonPlanCommand) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_LESSON_PLANS_ADD,
    command
  );
};

export const updateLessonPlan = (
  lessonPlanId: number,
  command: IUpdateLessonPlanCommand
) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_LESSON_PLANS_UPDATE.replace(
      ":lessonPlanId",
      lessonPlanId.toString()
    ),
    command
  );
};

export const searchLessonPlans = (filter: ILessonPlanSearch) => {
  return AxiosHelper.axiosInstance().get<PagingResponse<ILessonPlan>>(
    `${APIConstant.CMS_LESSON_PLANS_SEARCH}`,
    {
      params: filter,
    }
  );
};

export const getLessonPlanById = (lessonPlanId: number) => {
  return AxiosHelper.axiosInstance().get<ILessonPlan>(
    APIConstant.CMS_LESSON_PLANS_GET_BY_ID.replace(
      ":lessonPlanId",
      lessonPlanId.toString()
    )
  );
};

export const getLessonPlanBySubjectId = (subjectId: number) => {
  return AxiosHelper.axiosInstance().get<ILessonPlan>(
    APIConstant.CMS_LESSON_PLANS_GET_BY_SUBJECT_ID.replace(
      ":subjectId",
      subjectId.toString()
    )
  );
};

export const getSubjects = () => {
  return AxiosHelper.axiosInstance().get<Array<ILessonPlanSubject>>(
    `${APIConstant.CMS_LESSON_PLANS_GET_SUBJECTS}`
  );
};

export const addLessonPlanAsset = (lessonPlanId: number, asset: FormData) => {
  return AxiosHelper.axiosInstance().post<number>(
    APIConstant.CMS_LESSON_PLANS_ASSETS_ADD.replace(
      ":lessonPlanId",
      lessonPlanId.toString()
    ),
    asset,
    {}
  );
};

export const updateLessonPlanAsset = (
  lessonPlanId: number,
  lessonPlanAssetId: number,
  asset: FormData
) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_LESSON_PLANS_ASSETS_UPDATE.replace(
      ":lessonPlanId",
      lessonPlanId.toString()
    ).replace(":lessonPlanAssetId", lessonPlanAssetId.toString()),
    asset,
    {}
  );
};

export const getLessonPlanAssestsByLessonPlanId = (lessonPlanId: number) => {
  return AxiosHelper.axiosInstance().get<Array<ILessonPlanAsset>>(
    APIConstant.CMS_LESSON_PLANS_ASSETS_GET_BY_LESSON_PLAN_ID.replace(
      ":lessonPlanId",
      lessonPlanId.toString()
    )
  );
};

export const getLessonPlanAssetById = (
  lessonPlanAssetId: number,
  lessonPlanId: number
) => {
  return AxiosHelper.axiosInstance().get<ILessonPlanAsset>(
    APIConstant.CMS_LESSON_PLANS_ASSETS_GET_BY_ID.replace(
      ":lessonPlanId",
      lessonPlanId.toString()
    ).replace(":lessonPlanAssetId", lessonPlanAssetId.toString())
  );
};

export const getLessonPlanAssetUrl = (
  lessonPlanAssetId: number,
  lessonPlanId: number
) => {
  return AxiosHelper.axiosInstance().get<string>(
    APIConstant.CMS_LESSON_PLANS_ASSETS_GET_URL.replace(
      ":lessonPlanId",
      lessonPlanId.toString()
    ).replace(":lessonPlanAssetId", lessonPlanAssetId.toString())
  );
};
